export default {
  isSearchOpen: state => state.searchOpen,
  isSidebarOpen: state => state.sidebarOpen,
}
